import React from 'react';

import SimpleVersion from './SimpleVersion/SimpleVersion';
import styles from './MECharts.module.css';

export default function MECharts({
  version,
  welcomeJourneyStep,
  setWelcomeJourneyStep,
  processWelcomeJourney,
}) {
  return (
    <>
      <div className={styles.chartWrapper}>
        <SimpleVersion
          version={version}
          welcomeJourneyStep={welcomeJourneyStep}
          processWelcomeJourney={processWelcomeJourney}
          setWelcomeJourneyStep={setWelcomeJourneyStep}
        />
      </div>
    </>
  );
}
